import '@bjb/bjb-web-components/dist/components/jb-button-secondary/jb-button-secondary.js';
import '@bjb/bjb-web-components/dist/components/jb-button-panel/jb-button-panel.js';
import '@bjb/bjb-web-components/dist/components/jb-checkbox/jb-checkbox.js';
import '@bjb/bjb-web-components/dist/components/jb-form/jb-form.js';

import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { JbForm } from '../../../../storybook/src/components/jb-form/jb-form';

@customElement('jbgw-disclaimer')
export class JbgwDisclaimer extends LitElement {
  @property()
  agreeLabel: string

  @property()
  checkboxText: string|null = null;

  @property()
  disagreeLabel: string

  @property()
  headline: string

  @property()
  identifier: string

  @property()
  requiredText: string|null = null;

  private _handleAgreeClick(e: Event) {
    e.stopPropagation();

    const formEl = this.renderRoot.querySelector('jb-form') as unknown as JbForm;
    const isValid = formEl.validate();

    if (!isValid) {
      return;
    }

    this.dispatchEvent(
      new CustomEvent('jbgw-disclaimer:agree', {
        detail: { identifier: this.identifier },
        bubbles: true,
        composed: true,
      })
    );
  }

  private _handleDisagreeClick(e: Event) {
    e.stopPropagation();

    this.dispatchEvent(
      new CustomEvent('jbgw-disclaimer:disagree', {
        bubbles: true,
        composed: true,
      })
    );
  }

  render() {
    return html`
      <section>
        <jb-info-page-hero header=${this.headline} withSpacing></jb-info-page-hero>
        <slot></slot>
        <jb-form action="" withSpacing data-disclaimer-id="{data.uid}">
          ${this.checkboxText ? html`
            <jb-checkbox
              label=${this.checkboxText}
              requiredText=${this.requiredText}
            ></jb-checkbox>
          ` : null}
          <jb-button-panel>
            <jb-button-secondary @jb-button:clicked=${this._handleAgreeClick} name="agree">${this.agreeLabel}</jb-button-secondary>
            <jb-button-secondary @jb-button:clicked=${this._handleDisagreeClick} name="disagree">${this.disagreeLabel}</jb-button-secondary>
          </jb-button-panel>
        </jb-form>
      </section>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'jbgw-disclaimer': JbgwDisclaimer;
  }
}
